import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BoltIcon = (_a) => {
    var { size } = _a, rest = __rest(_a, ["size"]);
    return (_jsxs("svg", Object.assign({ width: size, height: size }, rest, { viewBox: '0 0 24 24', fill: 'none', strokeWidth: '1.5', stroke: 'currentColor', xmlns: 'http://www.w3.org/2000/svg', children: [_jsx("title", { children: "Bolt" }), _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'm3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z' })] })));
};
//# sourceMappingURL=bolt.icon.js.map